import React from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { paths } from '@/app/paths';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { IS_DEV, IS_PRE } from '@/utils/environment';
import crmLogo from '@/assets/images/folioCRM.png';
import darkCrmLogo from '@/assets/images/folioCRM_dark_matched.png';
import FolioWorkflowLogo from '@/components/layouts/FolioWorkflow';
import { IntegratedWithWinbeat } from '@/components/layouts/WinbeatNextLogo';
import { useSideNavStyle } from '../useSideNavStyle';

const useIsWinbeatLedger = () => {
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });
	return userDetails?.isWinbeatLedger;
};

export const CrmSideNavBrand = () => {
	const { inverted } = useSideNavStyle();
	const isWinbeatLedger = useIsWinbeatLedger();

	return (
		<Box component={Link} to={paths.home} sx={{ display: 'flex' }}>
			{isWinbeatLedger ? (
				<FolioWorkflowLogo
					height={IS_DEV || IS_PRE ? 18 : 22}
					variant={inverted ? 'light' : 'dark'}
				/>
			) : (
				<Box
					component='img'
					src={inverted ? darkCrmLogo : crmLogo}
					alt='CRM Logo'
					sx={{
						height: 22,
						width: 'auto',
						display: 'block',
					}}
				/>
			)}
		</Box>
	);
};

export const CrmSideNavBrandCaption = () => {
	const { inverted } = useSideNavStyle();
	const isWinbeatLedger = useIsWinbeatLedger();

	return isWinbeatLedger && <IntegratedWithWinbeat variant={inverted ? 'light' : 'dark'} />;
};
